import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { notification, modal, logError } from 'redux/modules/app'
import { tasks as tasksApi } from 'redux/modules/api'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, auth, app }) => ({
          user: auth.user,
          activeOrganizationId: auth.organization.id,
          tasksWWCUpdate: api.tasks.wwcUpdate,
          commonLimit: app.commonLimit,
        }),
        {
          ...tasksApi.wwcUpdate,
          getTasksOverview: tasksApi.overview.getTasksOverview,
          notification,
          modal,
          logError,
        }
      )
    )

    class TasksWWCUpdate extends Component {
      static propTypes = {
        decoFilter: PropTypes.string,
        user: PropTypes.object.isRequired,
        activeOrganizationId: PropTypes.number.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        decoFilterMyOnly: PropTypes.bool,
        modal: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        setWWCUpdateTasksParams: PropTypes.func,
        tasksWWCUpdate: PropTypes.object.isRequired,
        getTasksWWCUpdate: PropTypes.func,
        approveWWCUpdate: PropTypes.func,
        approveWWCUpdateWithoutFile: PropTypes.func,
        decoUpdateOrganizationOverview: PropTypes.bool,
        commonLimit: PropTypes.number
      }

      componentDidMount() {
        const { commonLimit, setWWCUpdateTasksParams, tasksWWCUpdate } = this.props

        if (config.useCommonLimit && commonLimit) {
          config.wwcUpdateTasks && setWWCUpdateTasksParams({ limit: commonLimit })
        } else {
          config.wwcUpdateTasks && this.handleGetTasksWWCUpdate(tasksWWCUpdate)
        }
      }

      componentWillReceiveProps(nextProps) {
        const { tasksWWCUpdate } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.tasksWWCUpdate

        if (
          tasksWWCUpdate.filter !== filter ||
          tasksWWCUpdate.limit !== limit ||
          tasksWWCUpdate.offset !== offset ||
          tasksWWCUpdate.sort !== sort ||
          tasksWWCUpdate.invalidate !== invalidate
        ) {
          this.handleGetTasksWWCUpdate(nextProps.tasksWWCUpdate)
        }
      }

      handleGetBaseFilter = () => {
        const { params, decoFilter } = this.props

        switch (decoFilter || config.filter) {
          case 'awardUnitRegistrations':
            return `organization.id=${params && params.id}`
          default:
            return ''
        }
      }

      handleGetTasksWWCUpdate = tasks =>
        this.props.getTasksWWCUpdate(tasks, this.handleGetBaseFilter())

      handleApproveWWCUpdate = assessorId => {
        this.props.approveWWCUpdate(assessorId, { approved: true })
          .then(() => {
            this.handleSuccess({
                label: 'WWC approved',
                intlKey: 'notifications.wwc_update_approved'
              })
          })
          .catch(this.handleError)
      }
      handleReturnWWCUpdate = assessorId => {
        this.props.approveWWCUpdate(assessorId, { approved: false })
          .then(() => {
            this.handleSuccess({
                label: 'WWC revised',
                intlKey: 'notifications.wwc_update_revised'
              })
          })
          .catch(this.handleError)
      }

      handleApproveWWCUpdateWithoutFile = assessorId => {
        this.props.approveWWCUpdateWithoutFile(assessorId, { approved: true })
            .then(() => {
              this.handleSuccess({
                label: 'WWC approved',
                intlKey: 'notifications.wwc_update_approved'
              })
            })
            .catch(this.handleError)
      }
      handleReturnWWCUpdateWithoutFile = assessorId => {
        this.props.approveWWCUpdateWithoutFile(assessorId, { approved: false })
            .then(() => {
              this.handleSuccess({
                label: 'WWC revised',
                intlKey: 'notifications.wwc_update_revised'
              })
            })
            .catch(this.handleError)
      }

      handleSuccess = (
        {
          label = 'WWC approved',
          intlKey = 'notifications.wwc_update_approved'
        } = {}
      ) => {
        const { tasksWWCUpdate } = this.props

        this.props.notification(label, {
          status: 'success',
          intlKey
        })

        this.handleRefresh(tasksWWCUpdate)
      }

      handleRefresh = tasksWWCUpdate => {
        const { decoUpdateOrganizationOverview, params } = this.props

        let id = null

        if (decoUpdateOrganizationOverview) {
          id = params.id
        }

        if (config.updateTasks) {
          this.handleGetTasksWWCUpdate(tasksWWCUpdate)
          this.props.getTasksOverview(null, {
            orgId: id,
            activeOrganizationId: this.props.activeOrganizationId,
            awardLeaderId: this.props.user.personId
          })
          this.props.modal(null)
        }
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        return (
          <ComposedComponent
            onApproveWWCUpdate={this.handleApproveWWCUpdate}
            onReturnWWCUpdate={this.handleReturnWWCUpdate}
            onApproveWWCUpdateWithoutFile={this.handleApproveWWCUpdateWithoutFile}
            onReturnWWCUpdateWithoutFile={this.handleReturnWWCUpdateWithoutFile}
            {...this.props}
          />
        )
      }
    }
    return enhance(TasksWWCUpdate)
  }
}

export default decorator
